jQuery(document).ready(function($) {

    new $.Zebra_Tooltips($('.tooltip_top'), {
        position:   'top',
        animation_offset: 0,
        animation_speed: 100,
        opacity: 1,
        show_delay: 0,
        hide_delay: 0
    });

    new $.Zebra_Tooltips($('.tooltip_below'), {
        position:   'below',
        animation_offset: 0,
        animation_speed: 100,
        opacity: 1,
        show_delay: 0,
        hide_delay: 0
    });

});
//# sourceMappingURL=tooltips.js.map
